import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || 'https://search.cim.org',
  validateStatus: function (status) {
    return status >= 200 && status < 400;
  }
});

// Log every request's full URL
instance.interceptors.request.use((config) => {
  //console.log('[Axios] Request URL:', config.baseURL + config.url);
  return config;
});

export default instance;
